







import Vue from "vue";
import Plots from "@/components/organisms/Plots.vue";
import PlotList from "@/components/organisms/PlotList.vue";
import { Plot, SubPlot } from "@/lib/models/plot";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { Plots, PlotList },
  props: {
    novelId: String,
    plotId: String,
  },
  async created() {
    const { $store, novelId } = this;
    const { dispatch } = $store;

    dispatch("plotModule/initialize", novelId);
  },
  computed: {
    plot() {
      const { $store, plotId } = this;

      if (plotId) {
        return $store.getters["plotModule/subPlot"](plotId);
      } else {
        return $store.getters["plotModule/plots"];
      }
    },
    subPlots() {
      const { $store } = this;
      return $store.getters["plotModule/subPlots"];
    },
  },
});

interface Props {
  novelId: string;
  plotId?: string;
}

interface Data {}

interface Computed {
  plot: Plot | SubPlot;
  subPlots: SubPlot[];
}

interface Methods {}
